<script>
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Gaming Impact');
    let global = 'global';
    let startdiv;
    import {onMount} from 'svelte';
    /**
     */
    function onStart() {
        startdiv.style.backgroundColor = 'transparent';
        global = 'globalafter';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    const image = [
        '/images/everyone_Gamer/section1BG.png',
        '/images/everyone_Gamer/section2BG.png',
        '/images/everyone_Gamer/section3BG.png',
        '/images/everyone_Gamer/section4BG.png',
        '/images/everyone_Gamer/section5BG.png',
    ];
    const sectionHeadings = ['section2text', 'header1', 'header2', 'header3'];
    const sectionHeadings4 = ['section4text', 'header5'];
    const sectionHeadings5 = ['section5text'];
    const section = [
        'section-before',
        'section',
        'section-after',
        'section-after',
        'section-after',
        'section-after',
    ];
    const BGimg = ['bgimg', 'bgimg', 'bgimg3', 'bgimg4', 'bgimg5'];
    const graph = ['graphide', 'graphide', 'graphide', 'graph', 'graphide'];
    const loader = ['graphide', 'graphide', 'graphide', 'graphide', 'loader'];
    const graphData = [
        {
            btype: '2.49B',
            year: '2018',
        },
        {
            btype: '2.64B',
            year: '2019',
        },
        {
            btype: '2.81B',
            year: '2020',
        },
        {
            btype: '2.96B',
            year: '2021',
        },
        {
            btype: '3.09B',
            year: '2022',
        },
    ];
    let i = 0;
    const j = 0;
    let Btype = 'btypebefore';
    const setTop = [];
    const graphHeight = [];
    const circleImages = [
        {
            text: 21,
            link: 'images/everyone_Gamer/green_circle.png',
            imageWidth: '9.427vw',
            imgHeight: '3.125vw',
            age: 'UNDER 18',
        },
        {
            text: 53,
            link: 'images/everyone_Gamer/blue_circle.png',
            imageWidth: '9.427vw',
            imgHeight: '5.665vw',
            age: '18-34 years',
        },
        {
            text: 26,
            link: 'images/everyone_Gamer/purple_circle.png',
            imageWidth: '9.271vw',
            imgHeight: '4.2vw',
            age: '35-54 years',
        },
    ];
    const circleTop = [];
    /**
 * Adds two numbers together.
 * @param {int} i The first number.
 * @param {int} j The second number.
 */
    function next() {
        i++;
        if (i === 5) {
            goto('/videoGaming');
        }
        if (i === j + 3) {
            setTop[0].style.top = '6.33vw';
            setTop[1].style.top = '4.927vw';
            setTop[2].style.top = '3.997vw';
            setTop[3].style.top = '2.926vw';
            setTop[4].style.top = '2vw';
            graphHeight[0].style.height = '7.938vw';
            graphHeight[1].style.height = '9.35vw';
            graphHeight[2].style.height = '10.25vw';
            graphHeight[3].style.height = '11.35vw';
            graphHeight[4].style.height = '12.25vw';
            Btype = 'btypeafter';
        }
        if (i === j + 4) {
            setTimeout(() => {
                if (circleTop && circleTop.length && circleTop[0] && circleTop[1] && circleTop[2]) {
                    circleTop[0].style.top = '6.314vw';
                    circleTop[1].style.top = '3.762vw';
                    circleTop[2].style.top = '5.380vw';
                }
            }, 1000);
        }
    }
    /**
 * Adds two numbers together.
 * @param {int} e The first number.
 */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/whygaming');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<section>
    <div class = 'startdiv' bind:this={startdiv} role="presentation" on:click={next}/>
    <div class="maindiv">
        <div class={section[i + 1]}>
            <div class={BGimg[i]}>
                <img src={image[i]} alt="" width="100%" height="100%" />
            </div>
            <div class="textdiv" class:hide={i > 0}>
                <p class="text1">GamING HAS the</p>
                <p class="text2">Direct game sale is low revenue/user</p>
            </div>
            <div class="header{i}">
                <p class={i === j ? 'heading1' : 'heading1after'}>Broadest</p>
                <p class={i === j ? 'heading2' : 'heading2after'} style="">impact</p>
            </div>
            <div class="bluediv" class:hide={i > 0}>
                <div class="inner">
                    <p class="text2">
                        Part of life for over <span style="color: #FF007F;"
                            >83.6%</span
                        > internet users
                    </p>
                    <p class="text2">
                        Projected to reach <span style="color: #FF007F;">
                            90%</span
                        > in next few years
                    </p>
                </div>
                <div class={global}>
                    <p class="text3">Gamers per internet users:</p>
                    <p class="text1">
                        <span class="text4" style="">83.6%</span> Globally
                    </p>
                    <p class="text2" style="color:#67EEBB;">(80.9% US)</p>
                </div>
            </div>
        </div>
        <div class={section[i]}>
            <div class="scndTextAfter" class:hide={i > 1}>
                <p class="text1">Gamers are</p>
                <p class="tec-text">
                    <span style="font-weight: 500;color:white;">of</span> new technology
                </p>
            </div>

            <div class={sectionHeadings[i - 1]}>
                <p class={i === j + 1 ? 'heading1' : 'heading1after'}>EARLY</p>
                <p
                    class={i === j + 1 ? 'headingSec2' : 'heading2after'}
                >
                    ADOPTERS
                </p>
            </div>
        </div>
        <div class={i > 1 ? section[i - 1] : 'section-before'}>
            <div class="trdTextAfter" class:hide={i > 2}>
                <p class="text1">Gamer HOUSEHOLDs HAVE</p>
                <p class="text1" style=" margin-top: 27.037vh;margin-left:31.354vw;">
                    THAN AVERAGE
                </p>
            </div>
            <div class="trdTextAfter" class:slideDown={i > 2}>
                <p class="houseText">
                    Household Income of <span
                        style="font-weight: 900;color:#FFCC33;">65%</span
                    >
                    gaming households in the US is
                    <span style="font-weight: 900;color:#FFCC33;">250K+</span>
                </p>
            </div>
            <div class={sectionHeadings[i - 2]}>
                <p class={i === j + 2 ? 'heading1' : 'heading1after'}>HIGHER</p>
                <p class={i === j + 2 ? 'headingSec3' : 'heading2after'} >INCOME</p>
            </div>
        </div>
        <div class={i > 2 ? section[i - 2] : 'section-before'}>
            <div class="forthTextAfter" class:hide={i > 3}>
                <p class="text1">Gamers ARE</p>
                <p class="text1" style="margin-top:15.463vh;">to</p>
                <p
                    class="marketHeading"
                    style="margin-top:4.537vh;color:white;"
                >
                    CONDITIONS
                </p>
            </div>
            <div class={sectionHeadings4[i - 3]}>
                <p class={i === j + 3 ? 'heading1' : 'heading1Swipe'}>
                    RESILIENT
                </p>
                <p class={i === j + 3 ? 'marketHeading' : 'heading2Swipe'}>
                    MARKET
                </p>
            </div>
        </div>
        <div class={graph[i]}>
            {#each graphData as data, id}
                <div class={Btype} class:bold={id===4}>
                    <p>{data.btype}</p>
                </div>
                <div class="innerGraph">
                    <div class="gdiv1">
                        <div class="dimImg">
                            <img
                                src="/images/everyone_Gamer/dimImg.png"
                                alt=""
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </div>
                    <div class="boxMain">
                        <div class="box2" bind:this={setTop[id]}></div>
                        <div class="box" bind:this={graphHeight[id]}>
                        </div>
                       
                    </div>
                   
                </div>
                <div class="year">
                    <p>{data.year}</p>
                </div>
            {/each}
        </div>
        {#if i === j + 3}
            <div class="blueDiv4">
                <p>Gamers numbers year over years</p>
            </div>
        {/if}
        <div class={i > 3 ? section[i - 3] : 'section-before'}>
            <div class="sec5text">
                <div class="sec5text-top">IS A</div>
                <div class="sec5text-bottom">
                    <span style="font-weight: 900;">3.3B</span>
                    <span style="color: #FFCC33;font-weight: 700">gamers</span>
                    out of
                    <span style="font-weight: 900"
                        >4.0B <br />internet users</span
                    >
                </div>
            </div>
            <div class={sectionHeadings5[i - 4]}>
                <p
                    style="font-size: min(7.813vw ,13.889vh); line-height: min(6.719vw ,11.944vh);"
                    class="{i === j + 4} heading1"
                >
                    EVERY <br />ONE
                </p>
                <p class="{i === j + 4} heading1" style="color: #FFCC33;">
                    GAMER
                </p>
            </div>
            <div class={loader[i]}>
                <div class="male">
                    <div class="male-img-wrapper">
                        <img
                            class:rotate-male={i === j + 4}
                            width="100%"
                            height="100%"
                            src="images/everyone_Gamer/male1.png"
                            alt=""
                        />
                        <div
                            class="loader-text"
                            class:slideUp-text={i === j + 4}
                        >
                            52%
                            <p>MALE</p>
                        </div>
                    </div>
                </div>
                <div class="female">
                    <div class="female-img-wrapper">
                        <img
                            class:rotate-female={i === j + 4}
                            width="100%"
                            height="100%"
                            src="images/everyone_Gamer/female.png"
                            alt=""
                        />
                        <div
                            class="loader-text"
                            class:slideUp-text={i === j + 4}
                        >
                            48%
                            <p>FEMALE</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="circles-box">
                {#each circleImages as circle, id}
                    <div class="items">
                        <div class="outer-circle">
                            <div class="inner-circle">
                                <div
                                    class="img-wrapper"
                                    bind:this={circleTop[id]}
                                    style="top: 8.502vw; width:{circle.imageWidth}; height:{circle.imgHeight};"
                                >
                                    <img
                                        width="100%"
                                        height="100%"
                                        src={circle.link}
                                        alt=""
                                    />
                                </div>
                                <div class="circle-text {i===j+4?'circle-fade':'graphide'}"  >
                                    {circle.text}%
                                </div>
                            </div>
                        </div>
                        <div class="age">
                            {circle.age}
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</section>

<style>
    .box{
        height: 3.854vw;
        width: 2.9vw;
        position: absolute;
        bottom: 0;
        transition-delay: 1.7s;
        transition-duration: 1s;
    }
    .box::after{
        content: "";
        height: inherit;
        width: 1.5vw;
        position: absolute;
        top: 0;
        background-color: #36F097;
            transform: skewY(19deg);
    }
    .box::before{
        content: "";
        height: inherit;
        width: 1.5vw;
        position: absolute;
        top: 0;
        left: 1.38vw;
        background-color: #3FB77E;  
        transform: skewY(-19deg) matrix(-1, 0, 0, 1, 0, 0);
    }
    .box2{
        height: 2.1vw;
        width: 2.1vw;
        background-color: #4CF097;
        position: absolute;
        left: 0.37vw;
        top: 10.4vw;
        transform: rotate(45deg) rotate3d(1, 1, 1, -60deg) rotatex(90deg);
        transform-style: preserve-3d;
        transition-delay: 1.7s;
        transition-duration: 1s;
    }
    img {
        pointer-events: none;
    }
    .sec5text {
        font-family: "Montserrat";
        font-style: normal;
        color: #ffffff;
        width: fit-content;
        height: 43.889vh;
        flex-direction: column;
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 35.185vh;
        left: 22.917vw;
        transition-duration: 1s;
    }
    .sec5text-top {
        font-weight: 700;
        /* font-size: 6.389vh; */
        font-size: min(3.594vw , 6.389vh);
        /* line-height: 7.685vh; */
        line-height: min(4.313vw , 7.685vh);
        text-align: right;
    }
    .sec5text-bottom {
        font-weight: 300;
        font-size: 3.704vh;
        line-height: 4.444vh;
    }
    .circles-box {
        position: absolute;
        top: 64.134vh;
        left: 57.02vw;
        width: 36.964vw;
        height: fit-content;
        display: flex;
        justify-content: space-between;
        text-align: center;
        transition-duration: 1s;
    }
    .outer-circle {
        position: relative;
        overflow: hidden;
        width: 9.948vw;
        height: 9.948vw;
        border: 0.104vw solid #ade1ff;
        border-radius: 50%;
    }
    .inner-circle {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 9.451vw;
        height: 9.451vw;
        border-radius: 50%;
        overflow: hidden;
        border: 0.104vw solid #ffffff;
    }
    .img-wrapper {
        position: absolute;
        transition-duration: 1s;
    }
    .circle-text {
        height: 100%;
        font-weight: 700;
        font-size: 2.083vw;
        line-height: 2.552vw;
        color: #ffffff;
        border: 0.104vw solid rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .circle-fade{
        animation: fadeDelay 100ms forwards 1.5s;
        transition-delay:1.5s;
    }
    @keyframes fadeDelay {
        0% {
            opacity: 0;
        }
    }
    .slideUp-text {
        animation: slideUpText 1s forwards;
        animation-delay: 1s;
    }
    @keyframes slideUpText {
        0% {
            opacity: 0;
            transform: translateY(0.7vw);
        }
    }
    .age {
        margin-top: 2.396vw;
        font-weight: 700;
        font-size: 1.042vw;
        line-height: 1.25vw;
        text-transform: uppercase;
        color: #ffcc33;
    }
    .loader {
        position: relative;
        top: 11.613vh;
        left: 62.73vw;
        width: 21.615vw;
        height: 23.281vw;
        font-family: "Montserrat";
        font-style: normal;
        transition-delay: 1s;
    }
    .male-img-wrapper {
        position: absolute;
        z-index: 10;
        width: 14.663vw;
        height: 23.281vw;
        right: 0;
    }
    .rotate-male {
        animation: rotateMale 1s forwards;
        animation-delay: 1s;
    }
    @keyframes rotateMale {
        0% {
            transform: rotate(173.23deg);
            transform-origin: 2vw center;
        }
        100% {
            transform: rotate(0deg);
            transform-origin: 2vw center;
        }
    }
    .female-img-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 18.906vw;
        width: 9.453vw;
    }
    .rotate-female {
        animation: rotateFemale 1s forwards;
        animation-delay: 1s;
    }
    @keyframes rotateFemale {
        0% {
            transform-origin: right center;
            transform: rotate(70deg);
        }
        100% {
            transform: rotate(0deg);
            transform-origin: right center;
        }
    }
    .loader-text {
        position: absolute;
        font-weight: 700;
        font-size: 3.125vw;
        line-height: 3.802vw;
        text-transform: uppercase;
        color: #101428;
        z-index: 20;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        text-align: center;
        margin: auto;
        height: fit-content;
    }
    .loader-text p {
        margin: 0;
        font-size: 1.25vw;
        line-height: 1.51vw;
    }

    .hide {
        opacity: 0;
        transition-duration: 1s;
    }
    .maindiv {
        position: relative;
        width: 100%;
        height: 100vh;
        background-color: #101428;
        overflow: hidden;
        font-family: "Montserrat";
    }
    .section1 {
        position: relative;
    }
    .bgimg {
        width: 66.823vw;
        /* height: 100vh; */
        margin: auto;
    }
    
    .bgimg3 {
        width: 40.885vw;
        /* height: 100vh; */
        float: right;
        margin-right: 4.375vw;
    }
    .bgimg4 {
        width: 78.073vw;
        /* height: 100vh; */
        float: left;
        margin-left: 4.74vw;
    }
    .bgimg5 {
        width: 66.823vw;
        /* height: 100vh; */
        margin: 2.5vw auto 0;
    }
    p {
        margin: 0;
    }
    .header0 {
        position: absolute;
        width: 64.3vw;
        top: 29.259vh;
        left: 18.177vw;
        opacity: 1;
        transition-duration: 1s;
    }
    .header1 {
        position: absolute;
        top: 50.185vh;
        left: 0vw;
        text-align: end;
        /* width: 11vw; */
        width: min(21.5vw,22.222vh);
        transition-duration: 1s;
    }
    .header2 {
        position: absolute;
        top: 41.759vh;
        left: 0vw;
        text-align: end;
        /* width: 11vw; */
        width: min(21.5vw,22.222vh);
        transition-duration: 1s;
    }
    .header3 {
        position: absolute;
        top: 34.352vh;
        left: 0vw;
        text-align: end;
        /* width: 11vw; */
        width: min(21.5vw,22.222vh);
        transition-duration: 1s;
    }
    .header4 {
        position: absolute;
        top: 26.944vh;
        left: 0vw;
        text-align: end;
        /* width: 11vw; */
        width: min(21.5vw,22.222vh);
        transition-duration: 1s;
    }
    .header5 {
        position: absolute;
        top: 50vh;
        left: 0vw;
        text-align: end;
        /* width: 11vw; */
        width: min(21.5vw,22.222vh);
        transition-duration: 1s;
    }
    .heading1 {
        font-weight: 900;
        /* font-size: 18.519vh; */
        font-size: min(10.417vw , 18.519vh);
        /* line-height: 13.796vh; */
        line-height: min(7.760vw , 13.796vh);
        text-transform: uppercase;
        color: #ff007f;
        opacity: 1;
        transition-duration: 1s;
    }
    .heading2 {
        margin-top: 2.593vh;
        /* text-align: end; */
        margin-left: 32.24vw;
        font-weight: 900;
        /* font-size: 13.889vh; */
        font-size: min(7.813vw , 13.889vh);
        /* line-height: 10.347vh; */
        line-height: min(5.820vw , 10.347vh);
        text-transform: uppercase;
        color: white;
        opacity: 1;
        transition-duration: 1s;
    }
    .headingSec2{
        margin-top: 2.593vh;
        margin-left: 1.042vw;
        font-weight: 900;
        font-size: min(7.813vw , 13.889vh);
        line-height: min(5.820vw , 10.347vh);
        text-transform: uppercase;
        color: white;
        opacity: 1;
        transition-duration: 1s;
    }
    .headingSec3{
        margin-top: 2.593vh;
        margin-left: 14.688vw;
        font-weight: 900;
        font-size: min(7.813vw , 13.889vh);
        line-height: min(5.820vw , 10.347vh);
        text-transform: uppercase;
        color: white;
        opacity: 1;
        transition-duration: 1s;
    }
    .marketHeading {
        margin-top: 2.593vh;
        margin-left: 4.479vw;
        text-align: start;
        font-weight: 900;
        /* font-size: 9.259vh; */
        font-size: min(5.208vw , 9.259vh);
        /* line-height: 6.898vh; */
        line-height: min(3.880vw , 6.898vh);
        text-transform: uppercase;
        color: #ffcc33;
        opacity: 1;
        transition-duration: 1s;
    }
    .textdiv {
        position: absolute;
        width: 64.3vw;
        top: 23.704vh;
        left: 18.177vw;
        transition-duration: 1s;
    }
    .heading1after {
        opacity: 0.4;
        font-size: 3.704vh;
        line-height: 2.759vh;
        text-align: end;
        font-weight: 900;
        color: #ff007f;
        transition: 1000ms;
        text-transform: uppercase;
    }
    .heading2after {
        opacity: 0.4;
        font-weight: 900;
        font-size: 3.704vh;
        line-height: 2.759vh;
        margin-top: 0vw;
        /* text-align: end; */
        color: white;
        transition: 1000ms;
        text-transform: uppercase;
    }
    .heading1Swipe {
        position: absolute;
        top: 2.8vh;
        opacity: 0.4;
        font-weight: 900;
        font-size: 3.704vh;
        line-height: 2.759vh;
        margin-top: 0vw;
        text-align: end;
        color: #ff007f;
        transition: 1000ms;
        text-transform: uppercase;
        width: 11vw;
        transition-duration: 1s;
    }
    .heading2Swipe {
        position: absolute;
        top: 0;
        opacity: 0.4;
        font-weight: 900;
        font-size: 3.704vh;
        line-height: 2.759vh;
        margin-top: 0vw;
        text-align: end;
        color: white;
        transition: 1000ms;
        text-transform: uppercase;
        width: 11vw;
        transition-duration: 1s;
    }

    .textdiv p:nth-child(2) {
        margin-top: 29.352vh;
    }
    .text1 {
        font-weight: 700;
        /* font-size: 3.704vh; */
        font-size: min(2.083vw , 30704vh);
        /* line-height: 4.444vh; */
        line-height: min(2.500vw, 4.444vh);
        text-transform: uppercase;
        color: #ffffff;
        transition-duration: 1s;
    }

    .text2 {
        width: 20.208vw;
        font-weight: 500;
        /* font-size: 2.778vh; */
        font-size: min(1.563vw , 2.778vh);
        /* line-height: 2.778vh; */
        line-height: min(1.563vw , 2.778vh);
        color: white;
        transition-duration: 1s;
    }
    .bluediv {
        display: flex;
        position: absolute;
        width: 100%;
        height: 17.87vh;
        background-color: #101428;
        bottom: 14.815vh;
        transition-duration: 1s;
    }
    .inner {
        padding: 1.296vh 0 0.052vw 18.177vw;
        transition-duration: 1s;
    }
    .inner p:nth-child(2) {
        margin-top: 5.556vh;
    }
    .globalafter {
        margin: 2.593vh 0 0 14.79vw;
        transition-duration: 1s;
    }
    .global {
        margin: 2.593vh 0 0 24.79vw;
    }
    .text3 {
        font-weight: 400;
        /* font-size: 1.852vh; */
        font-size: min(1.042vw , 1.852vh);
        /* line-height: 1.852vh; */
        line-height: min(1.042vw, 1.852vh);
        color: #ffcc33;
        text-transform: uppercase;
    }
    .text4 {
        font-weight: 700;
        /* font-size: 5.556vh; */
        font-size: min(3.125vw , 5.556vh);
        /* line-height: 6.667vh; */
        line-height: min(3.750vw, 6.667vh);
        color: #ffcc33;
    }
    .section {
        position: relative;
        width: 100%;
        height: 100vh;
        left: 0vw;
        top: 0;
        transition-duration: 1s;
    }
    .section-before {
        position: relative;
        width: 100%;
        height: 100vh;
        left: 100vw;
        top: 0;
        transition: 1s;
    }
    .section-after {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        transition: 1s;
    }
    .section2text {
        position: absolute;
        left: 26.042vw;
        top: 34.907vh;
        width: 46.354vw;
        transition-duration: 1s;
    }
    .section5text {
        position: absolute;
        left: 21.875vw;
        top: 19.907vh;
        width: 46.354vw;
        transition-duration: 1s;
    }
    .section4text {
        position: absolute;
        left: 22.813vw;
        top: 25.296vh;
        width: 46.354vw;
        transition-duration: 1s;
    }
    .scndTextAfter {
        position: absolute;
        top: 29.722vh;
        left: 26.563vw;
        /* width: 41vw; */
        transition-duration: 1s;
    }
    .trdTextAfter {
        position: absolute;
        top: 29.722vh;
        left: 26.563vw;
        /* width: 45.7vw; */
        transition-duration: 1s;
    }
    .forthTextAfter {
        position: absolute;
        top: 20.819vh;
        left: 22.813vw;
        width: 45.7vw;
        transition-duration: 1s;
    }
    .tec-text {
        margin-top: 27.037vh;
        font-weight: 900;
        /* font-size: 5.556vh; */
        font-size: min(3.125vw, 5.556vh);
        /* line-height: 6.667vh; */
        line-height: min(3.750vw , 6.667vh);
        color: #ffcc33;
        /* text-align: end; */
        margin-left: 9.063vw;
        text-transform: uppercase;
    }
    .houseText {
        /* width: 70vw; */
        margin-left: -11.542vw;
        margin-top: 46.111vh;
        font-weight: 300;
        /* font-size: 3.704vh; */
        font-size: min(2.083vw , 3.704vh);
        line-height: min(2.500vw , 4.444vh);
        /* line-height: 4.444vh; */
        text-transform: uppercase;
        color: #ffffff;
        transition-duration: 1s;
    }
    .slideDown {
        animation: slide 1s forwards;
    }
    @keyframes slide {
        0% {
            top: 29.722vh;
        }
        100% {
            top: 55vh;
        }
    }
    .graphide {
        opacity: 0;
        position: absolute;
    }
    .graph {
        opacity: 1;
        width: 26vw;
        height: 15.54vw;
        position: absolute;
        bottom: 15.093vh;
        right: 9.188vw;
        display: flex;
        justify-content: space-between;
    }
    .innerGraph {
        height: 15.54vw;
        position: relative;
    }
    .dimImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 2.917vw;
        height: 15.6vw;
    }
    .gdiv1 {
        width: 20vw;
        height: 15.31vw;
        position: absolute;
        overflow: hidden;
    }
    .year {
        font-weight: 400;
        font-size: 0.833vw;
        line-height: 1.042vw;
        text-align: center;
        color: #7c7c7a;
        position: relative;
        left: 0.35vw;
        top: 17vw;
    }
    .year:last-child {
        font-weight: 700;
        color: white;
    }
    .btypebefore {
        opacity: 0;
    }
    .btypeafter {
        opacity: 1;
        font-weight: 500;
        font-size: 0.729vw;
        line-height: 0.885vw;
        text-align: center;
        color: #ffffff;
        position: relative;
        left: 2.8vw;
        top: -2vw;
        transition-delay: 1.9s;
        transition-duration: 1s;
    }
    .bold {
        font-weight: 700;
        font-size: 1.042vw;
        line-height: 1.25vw;
        left: 3.2vw;
    }
    .blueDiv4 {
        position: absolute;
        right: 0;
        width: 40.156vw;
        height: 4.26vh;
        background: #101428;
        color: #ffcc33;
        bottom: 1vw;
        font-weight: 700;
        font-size: 1.042vw;
        text-align: center;
        padding-top: 1.759vh;
    }
    .startdiv{
        position: absolute;
        background-color: #101428;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
        left: 0vw;
        z-index: 4;
        transition-duration: 0.8s;
    }
</style>
